export default __webpack_public_path__ + "static/media/img1.45f9ef2e.png";